import React, { useEffect } from 'react'
import Layout from '../components/Layout'
import Form from '../components/Form'
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { fetchJob } from '../features/job/jobSlice'

export default function EditJob() {
  const dispatch = useDispatch()
  const { job } = useSelector(state => state.job)
  const { jobId } = useParams() || {}

  useEffect(() => {
    dispatch(fetchJob(jobId))
  }, [dispatch, jobId])

  return (
    <Layout>
      <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
        <h1 className="mb-10 text-center lws-section-title">Edit Job</h1>

        <div className="max-w-3xl mx-auto">
          <Form job={job} mode="edit" />
        </div>
      </main>
    </Layout>
  )
}
